<template>
  <v-snackbar
    v-model="show"
    :timeout="timeout"
    :success="type === 'success'"
    :info="type === 'info'"
    :warning="type === 'warning'"
    :error="type === 'error'"
    :primary="type === 'primary'"
    :secondary="type === 'secondary'"
    bottom
    multi-line
  >
    {{ text }}
    <v-btn icon dark flat @click.native="show = false">
      <v-icon dark>close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
  export default {
    data () {
      return {
        show: false,
        type: null,
        text: null,
        timeout: 5000
      }
    },
    mounted () {
      this.text = this.snackbar[0].text
      this.type = 'type' in this.snackbar[0] ? this.snackbar[0].type : this.type
      this.timeout = 'timeout' in this.snackbar[0] ? this.snackbar[0].timeout : this.timeout
      this.show = true
    },
    watch: {
      show (value) {
        if (value === false) {
          setTimeout(() => {
            this.removeFromStore()
          }, 500)
        }
      }
    },
    computed: {
      snackbar () {
        return this.$store.getters['utils/snackbar']
      }
    },
    methods: {
      removeFromStore () {
        this.$store.dispatch('utils/hideSnackbar')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Snackbar.vue?1aab43de